import { cache } from "react"
import directusServer from "./directus/directusGraphQLInstance"
import { rethrowIfDatabaseUnavailable } from "./errors/database"

const getAllPosts = cache(async () => {
  try {
    const response = await directusServer.query(`
     query allBlogSkills {
				skills(
						sort:  "slug",
						filter: { status: { _eq: "published" } }
					) {
						id
						slug
						name
						svg_logo
						svg_color_icon
						description
						area
						icon_color
					}
				}
	 	 `)
    // console.log(response);

    return response
  } catch (error) {
    rethrowIfDatabaseUnavailable(error)
    console.error(error)
    return null
  }
})

export default getAllPosts
